import { AuthFetchWithResponse } from 'src/Types/api'
import { ApiResult } from 'src/Libs/api'
import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchError } from '@e3dc-react/shell/Types'
import { handleFetchError } from 'src/Libs/api/utils'
import { tariffsModeDtoToModelTransformer } from '../transformer'
import { TariffsModeDto } from '../dto'
import { TariffsModeModel } from '../model'

export const getTariffsMode = async (installationId: number, authFetch: AuthFetchWithResponse): Promise<ApiResult<TariffsModeModel | null>> => {
  try {
    const response = await authFetch<TariffsModeDto>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `tariffs/${installationId}/mode`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<TariffsModeModel>(tariffsModeDtoToModelTransformer(response.data))
  } catch (error) {
    return handleFetchError<TariffsModeModel>(error)
  }
}
